import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../common/Input';
import { debounce } from '../../utils/helpers';
import { Search } from 'lucide-react';

interface PatientSearchProps {
  onSearch: (query: string) => void;
  debounceMs?: number;
}

export const PatientSearch: React.FC<PatientSearchProps> = ({
  onSearch,
  debounceMs = 300,
}) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const debouncedSearch = debounce<[string]>((searchQuery) => {
    onSearch(searchQuery);
  }, debounceMs);

  useEffect(() => {
    debouncedSearch(query);
  }, [query]);

  return (
    <div className="mb-4">
      <Input
        type="text"
        placeholder={t('common.search') + ' ' + t('patients.title').toLowerCase()}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        icon={<Search size={18} />}
      />
    </div>
  );
};
